import {ItemsState, ItemsStateData} from './ItemsStore.types';

import {Store} from '@/stores/Store';

const initialItemsState: ItemsState = {
  items: [],
};

export class ItemsStore extends Store<ItemsState> {
  constructor() {
    super(initialItemsState);
  }

  public setItems(items: ItemsStateData[]): void {
    this.setState({
      items,
    });
  }

  public getItems = (): ItemsStateData[] => {
    return this.getState().items;
  };

  // возвращает список айтемов, где вначале списка находятся отсортированные
  // по весам айтемы со статистикой, а в конце списка отсортированные по весам айтемы без статистики
  public getItemsSortedByStatisticContent = (): ItemsStateData[] => {
    const allItems = this.getItems();
    const itemsWithStatistic: ItemsStateData[] = [];
    const itemsWithoutStatistic: ItemsStateData[] = [];

    for (let i = 0; i < allItems.length; i++) {
      const item = allItems[i];

      if (item.itemStatisticContent.length !== 0) {
        itemsWithStatistic.push(item);
      } else {
        itemsWithoutStatistic.push(item);
      }
    }

    const sortedItemsWithStatistic = itemsWithStatistic.sort((a, b) => b.weight - a.weight);
    const sortedItemsWithoutStatistic = itemsWithoutStatistic.sort((a, b) => b.weight - a.weight);

    return [...sortedItemsWithStatistic, ...sortedItemsWithoutStatistic];
  };
}
